import { render, staticRenderFns } from "./Itinerary.vue?vue&type=template&id=6f2c3aaf&scoped=true"
import script from "./Itinerary.vue?vue&type=script&lang=js"
export * from "./Itinerary.vue?vue&type=script&lang=js"
import style0 from "./Itinerary.vue?vue&type=style&index=0&id=6f2c3aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c3aaf",
  null
  
)

export default component.exports